__turbopack_context__.v({
  "captionDarkMode": "styles-module-scss-module__gjQLfq__captionDarkMode",
  "gameDialogCaption": "styles-module-scss-module__gjQLfq__gameDialogCaption",
  "gameLandingCaption": "styles-module-scss-module__gjQLfq__gameLandingCaption",
});
